import { PageController } from '@client/components/_core/layout/PageController';
import { PdsEdit } from '@client/components/pds/PdsEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/configuration/claims-products/product-types/$productTypeId/edit/$pdsId',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Edit PDS',
        },
    },
    params: {
        parse({ pdsId }) {
            return {
                pdsId: BigInt(pdsId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <PdsEdit action={['edit', Route.useParams().pdsId]} />
        </PageController>
    );
}
